import { SyntheticEvent, useCallback, useEffect, useMemo, useState } from "react";
import { TfaMethod } from "@/core/constants/tfaMethod";
import useAppSelector from "@/core/helpers/useAppSelector";
import { Country } from "@/domains/account/constants/country";
import { countriesSelector } from "@/domains/account/slice";
import useChangePassword from "@/domains/playerMenu/hooks/useChangePassword";
import PlayerMenuSettingsSafetyChangePasswordSMSCheckContainer from "@/domains/playerMenu/containers/settings/safety/change-password/method/check/PlayerMenuSettingsSafetyChangePasswordSMSCheckContainer";
import PlayerMenuSettingsSafetyChangePasswordSMSSend from "@/domains/playerMenu/components/settings/safety/changePassword/method/PlayerMenuSettingsSafetyChangePasswordSMSSend";

type Props = {
  setStep: (step: number) => void;
  goToChangePassword: () => void;
};

export default function PlayerMenuSettingsSafetyChangePasswordSMSContainer({
  setStep,
  goToChangePassword,
}: Props) {
  const countries = useAppSelector(countriesSelector);
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [country, setCountry] = useState<Country>(Country.Russia);
  const { sendCodeHandler, sendIsPending, sendError, sendIsCompleted } = useChangePassword();

  const currCountry = useMemo(() => {
    const findedCountry = countries.find((item) => item.country === country);
    return findedCountry;
  }, [countries, country]);

  const onSubmit = useCallback(
    async (e: SyntheticEvent<HTMLFormElement>) => {
      e.preventDefault();
      const phone = `${currCountry.code}${phoneNumber}`;
      if (phone.length) {
        sendCodeHandler(`${currCountry.code}${phoneNumber}`, TfaMethod.SMS);
      }
    },
    [phoneNumber, currCountry],
  );

  const onChangeCountry = useCallback((value: Country) => {
    setCountry(value);
  }, []);

  const onPhoneNumberChageHandler = useCallback((phone: string) => {
    let value = phone;
    if (value.length > 10) {
      value = value.slice(0, 10);
    }
    setPhoneNumber(value);
  }, []);

  useEffect(() => {
    if (sendIsCompleted) {
      setStep(2);
    } else {
      setStep(1);
    }
  }, [sendIsCompleted]);

  if (sendIsCompleted) {
    return (
      <PlayerMenuSettingsSafetyChangePasswordSMSCheckContainer
        address={`${currCountry.code}${phoneNumber}`}
        goToChangePassword={goToChangePassword}
      />
    );
  }

  return (
    <PlayerMenuSettingsSafetyChangePasswordSMSSend
      error={sendError}
      phoneNumber={phoneNumber}
      onPhoneNumberChange={onPhoneNumberChageHandler}
      onSubmit={onSubmit}
      countries={countries}
      country={currCountry}
      onChangeCountry={onChangeCountry}
      pending={sendIsPending}
    />
  );
}
